<template>
  <div class="front-container front-coupon-container">
    <div class=" d-flex  justify-content-center align-items-center">
      <h2>請抽獎</h2>
      <div class="box mr-3 casino-box casino-box-a">
        <div
          class="groups animation-ease"
          v-for="k in 3"
          @webkitTransitionEnd="endGame(k)"
          :key="k"
        >
          <ul class="group-item" v-for="i in round + 1" :key="i">
            <li
              class="prize-item d-flex justify-content-center align-items-center"
              v-for="item in prizes"
              :key="item"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bar casino-box casino-box-b" @click="startClick">
      <div class="holdbar"></div>
      <div class="hold"></div>
    </div>
    <div class="fixed-title"><span>優惠</span></div>
  </div>
</template>

<script>
import couponRequests from '@/assets/js/api/front/apinFrontCoupon';
import $ from 'jquery';
export default {
  created() {},
  data() {
    return {
      round: 6, //轉幾回合
      prizes: [1, 5, 7, 8, 9],
      disClick: false, //防止連點
      itemHeight: 0, //獎品高度
      prize_id: '', //中獎ID
    };
  },
  mounted() {
    this.itemHeight = $('.prize-item').outerHeight();
    this.$nextTick(() => {
      document.getElementById('check').checked = false;
    });
  },
  methods: {
    startClick() {
      $('.hold').addClass('down');
      //開始抽獎
      if (this.disClick) {
        return;
      }
      //獲取ID
      let index = parseInt(Math.random() * this.prizes.length);
      this.prizd_id = this.prizes[index];
      this.runGame(index);
    },
    runGame(index) {
      //啟動抽獎
      this.disClick = true;
      this.resetGame();
      let itemHeight = this.itemHeight;
      let groupsHeight = this.round * $('.group-item').height();
      $('.groups').each(function(e) {
        let pos = index * itemHeight + groupsHeight;
        setTimeout(() => {
          $(this)
            .addClass('animation-ease')
            .css('transform', 'translate(0, -' + pos + 'px)');
        }, e * 300);
      });
    },
    endGame(k) {
      //抽獎結束後發動
      if (k == 3) {
        let code = null;
        if (this.prizd_id === 1) {
          code = '111';
        }
        if (this.prizd_id === 5) {
          code = '555';
        }
        if (this.prizd_id === 7) {
          code = '777';
        }
        if (this.prizd_id === 8) {
          code = '888';
        }
        if (this.prizd_id === 9) {
          code = '999';
        }
        couponRequests
          .post('', {
            code,
          })
          .then(res => {
            if (res.status === 200) {
              this.$fire({
                title: `${res.data.data.title}優惠碼會自動顯示!`,
                type: 'success',
                timer: 3000,
              });
              localStorage.removeItem('couponCode');
              localStorage.setItem('couponCode', res.data.data.code);
            }
          })
          .catch(err => {
            this.$fire({
              title: `${err}`,
              type: 'error',
              timer: 3000,
            });
          });
        this.disClick = false;
        $('.hold').removeClass('down');
      }
    },
    resetGame() {
      //重置
      $('.groups')
        .removeClass('animation-ease')
        .css('transform', '');
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 100px;
  font-size: 36px;
  width: 300px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.box {
  width: 600px;
  height: 100px;
  background: rgba(255, 255, 255, 0);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  .animation-ease {
    transition-property: transform;
    transition-duration: 3s;
    transition-timing-function: ease;
  }
  .groups {
    float: left;
    width: 200px;
    text-align: center;
    .prize-item {
      width: 200px;
      height: 100px;
      font-size: 50px;
      color: #000000;
      @media (max-width: 768px) {
        & {
          width: 100px;
        }
      }
    }
    @media (max-width: 768px) {
      & {
        width: 75px;
      }
    }
  }
  @media (max-width: 768px) {
    & {
      width: 250px;
    }
  }
}

.bar {
  position: absolute;
  height: 400px;
  width: 40px;
  border: 1px solid #000;
  right: 100px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  border-radius: 50px;
  @media (max-width: 768px) {
    right: 30px;
  }
}

.holdbar {
  content: '';
  display: block;
  width: 20px;
  height: 200px;
  border: 1px solid #000;
  position: absolute;
  bottom: 50%;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 10px;
}
.down {
  animation: down 1s;
}

.hold {
  width: 80px;
  height: 80px;
  border: 1px solid #000;
  background: #000;
  border-radius: 50%;
  position: absolute;
  left: -50%;
  top: -10%;
  cursor: pointer;
}

.hold::before {
  content: '';
  display: block;
  position: absolute;
  top: 5%;
  right: 0;
  left: 0;
  margin: 0 auto;
  border-radius: 60% 60% 50% 50%;
  width: 40%;
  height: 30%;
  background-image: linear-gradient(#fff 10%, transparent);
}

@keyframes down {
  0% {
    transform: translateY(0px) scale(1);
  }

  100% {
    transform: translateY(250px) scale(1.5);
  }
}
</style>
